import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20.418} height={10.811} {...props}>
    <path
      data-name="Arrow Collapse 20"
      d="M19.199 10.81a1.217 1.217 0 0 1-.834-.331l-8.09-7.595-8.23 7.6a1.219 1.219 0 0 1-1.722-.067A1.219 1.219 0 0 1 .39 8.695L9.454.324a1.216 1.216 0 0 1 1.66.007l8.918 8.371a1.217 1.217 0 0 1 .055 1.721 1.212 1.212 0 0 1-.888.387Z"
      fill="#f2f2f2"
    />
  </svg>
);

export default SvgComponent;
